import React from 'react'

const CommentsContext = React.createContext();

export default CommentsContext;
